export const APPLY_EAGRID_QUERY_RESULT_EVENT = 'apply_eag_grid_query_result_event';

export type ApplyDataGridQueryOutcome = 'applied' | 'failed';

export type ApplyEagridQueryResultCustomEvent = {
  gridCode: string;
  dataQueryId: string;
  outcome: ApplyDataGridQueryOutcome;
  requestId?: string;
};

declare global {
  interface WindowEventMap {
    [APPLY_EAGRID_QUERY_RESULT_EVENT]: CustomEvent<ApplyEagridQueryResultCustomEvent>;
  }
}

/** Callers correlate on the requestId they sent (several grids and retries may be in flight). */
export const dispatchApplyDataGridQueryResult = (detail: ApplyEagridQueryResultCustomEvent) => {
  window.dispatchEvent(new CustomEvent(APPLY_EAGRID_QUERY_RESULT_EVENT, {detail}));
};
